export const DEFAULT_DEVICE_ID = 'default';

export const BASE_PASSWORD_LENGTH = 12;
export const MEETING_LINK_ID_LENGTH = 10;
export const URL_PASSWORD_PREFIX = '#pwd-';
export const URL_ID_PREFIX = 'id-';
export const PAGE_SIZE = 15;
export const SCREEN_SHARE_PAGE_SIZE = 6;
export const SMALL_SCREEN_PAGE_SIZE = 4;
